export class RegistrantEmailCheck {
    private resultsCallback: (data: any) => void = () => { };
    private errorCallback: (request: any, status: any, error: any) => void = () => { };

    constructor(selector) {
        const $select = $(selector);   
        const searchUrl = $select.data("check-registrant-email-url");
        $(selector).on("change", (e) => {
            const email = e.target.value;
            this.checkEmail(searchUrl, email);
        });
    }

    private checkEmail(url, email) {
        $.ajax({
            url: url,
            data: {
                "email": email
            }
        }).done((data) => {
            this.processResults(data);
        }).fail((request, status, error) => {
            this.processError(request, status, error);
        });
    }

    private processResults(data: any) {
        // Run any success methods here before user provided callback
        this.resultsCallback(data);
    }

    private processError(request:any, status:any, error: any) {
        // Run any error methods here before user provided callback
        this.errorCallback(request, status, error);
    }

    onComplete(callback: (data: any) => void): RegistrantEmailCheck {
        this.resultsCallback = callback;
        return this;
    }

    onError(callback: (request: any, status: any, error: any) => void): RegistrantEmailCheck {
        this.errorCallback = callback;
        return this;
    }
}